import { assert, Test } from "oc-e2e-testrunner";
import {
  createMauer,
  logParts,
  resetArrangement,
  verteileGleichmaessigUndAssertGleichmaessigeBreiten,
} from "./utils";
import { v3 } from "oc-threejs/short3";
import { ZElement } from "../arrangement/ZElement";
import {
  getAngrenzendeTeile,
  getIstSollZwischenabstandDelta,
  getZwischenabstandAnSeiteVerbose,
  getZwischenabstandVerbose,
  LINKS,
  RECHTS,
  toAbschnittsteil,
} from "../arrangement/elementFunctions";

export default {
  name: "TestRechteckGleichmaessigVerteilen",
};

function setRechteckBreite(breite) {
  resetArrangement();
  APP.arrangement.grundriss.setStandardForm("Rechteck", [breite, breite], [true, true, true, true]);
  return breite;
}

function checkGleichmaessigVerteilen() {
  const agt = APP.arrangement;
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  for (const s of agt.segmente) {
    const parts = verteileGleichmaessigUndAssertGleichmaessigeBreiten(s);
  }
}

export const test1m: Test = async () => {
  setRechteckBreite(1);
  checkGleichmaessigVerteilen();
};

export const test2m: Test = async () => {
  setRechteckBreite(2);
  checkGleichmaessigVerteilen();
};

export const test10m: Test = async () => {
  setRechteckBreite(10);
  checkGleichmaessigVerteilen();
};

export const test5mMauerRechts: Test = async () => {
  const breite = setRechteckBreite(5);
  createMauer({ position: v3(breite / 2, 0, breite / 2), size: v3(1, 2, 1) });
  checkGleichmaessigVerteilen();
};

export const test5mMauerLinks: Test = async () => {
  const breite = setRechteckBreite(5);
  createMauer({ position: v3(-breite / 2, 0, breite / 2), size: v3(1, 2, 1) });
  checkGleichmaessigVerteilen();
};

export const test5mMauerLinksRechts: Test = async () => {
  const breite = setRechteckBreite(5);
  createMauer({ position: v3(-breite / 2, 0, breite / 2), size: v3(1, 2, 1) });
  createMauer({ position: v3(breite / 2, 0, breite / 2), size: v3(1, 2, 1) });
  checkGleichmaessigVerteilen();
};

export const test5mMauerMitte: Test = async () => {
  const breite = setRechteckBreite(5);
  createMauer({ position: v3(0, 0, breite / 2), size: v3(1, 2, 1) });
  checkGleichmaessigVerteilen();
};

export const testMasseUnverändertRechteck: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 1;
  agt.grundriss.setStandardForm("Rechteck", [breite, breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const vorher = logParts(s, s.parts);
  const element = s.parts[0] as ZElement;
  [LINKS, RECHTS].forEach((seite) => {
    const angrenzendeTeile = getAngrenzendeTeile(element, seite);
    assert.isNull(angrenzendeTeile.element, "darf sich nicht selbst zurückgeben");
    const ist = getZwischenabstandAnSeiteVerbose(element, seite);
    const teile = [
      toAbschnittsteil(angrenzendeTeile.pfosten ?? angrenzendeTeile.ecke),
      toAbschnittsteil(element),
    ];
    if (seite == RECHTS) {
      teile.reverse();
    }
    const [teilLinks, teilRechts] = teile;
    const soll = getZwischenabstandVerbose(teilLinks, teilRechts, agt);
    assert.deepEquals(
      { ...soll, richtung: seite },
      { ...ist, richtung: seite },
      "soll rot (getZwischenabstandVerbose), ist grün (getZwischenabstandAnSeiteVerbose)"
    );
  });

  const deltaLinks = getIstSollZwischenabstandDelta(element, element, LINKS);
  assert.equals(0, deltaLinks);
  const deltaRechts = getIstSollZwischenabstandDelta(element, element, RECHTS);
  assert.equals(0, deltaRechts);

  s.verteileBauseitsKürzbareElementeGleichmäßig(s.parts);
  const nachher = logParts(s, s.parts);
  assert.deepEquals(vorher, nachher);
};
